"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_types_1 = require("./workflow-designer.types");
var WorkflowDesignerPointModel = /** @class */ (function () {
    function WorkflowDesignerPointModel() {
        this.type = workflow_designer_types_1.WorkflowDesignerType.POINT;
        this._x = 0;
        this._y = 0;
        this._moveX = 0;
        this._moveY = 0;
        this.centerX = 0;
        this.centerY = 0;
        this.onDragStart = null;
        this.onDragEnd = null;
        this.onMove = null;
        this.locked = false;
        this.moving = false;
        this.editing = false;
        this.attr = {};
    }
    Object.defineProperty(WorkflowDesignerPointModel.prototype, "x", {
        get: function () {
            return this._x;
        },
        set: function (x) {
            this._x = x;
            this._moveX = x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerPointModel.prototype, "y", {
        get: function () {
            return this._y;
        },
        set: function (y) {
            this._y = y;
            this._moveY = y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerPointModel.prototype, "showGizmo", {
        get: function () {
            return this.moving || this.editing;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerPointModel.prototype.position = function (x, y) {
        if (!this.moving) {
            this.x = x;
            this.y = y;
        }
        return this;
    };
    WorkflowDesignerPointModel.prototype.dragStart = function (viewport) {
        if (viewport === void 0) { viewport = null; }
        this.onDragStart && this.onDragStart(this, viewport);
        this.moving = true;
    };
    WorkflowDesignerPointModel.prototype.dragEnd = function (viewport) {
        if (viewport === void 0) { viewport = null; }
        this.moving = false;
        this.onDragEnd && this.onDragEnd(this, viewport);
    };
    WorkflowDesignerPointModel.prototype.onDrop = function () {
        return this;
    };
    WorkflowDesignerPointModel.prototype.setAttr = function (name, value) {
        this.attr[name] = value;
        return this;
    };
    WorkflowDesignerPointModel.prototype.move = function (x, y, snap, viewport) {
        if (snap === void 0) { snap = 10; }
        if (viewport === void 0) { viewport = null; }
        if (this.moving) {
            snap = snap > 1 ? snap : 1;
            this._moveX += x;
            this._moveY += y;
            this._x = Math.round(this._moveX / snap) * snap;
            this._y = Math.round(this._moveY / snap) * snap;
            this.onMove && this.onMove(this, viewport);
        }
    };
    return WorkflowDesignerPointModel;
}());
exports.WorkflowDesignerPointModel = WorkflowDesignerPointModel;
//# sourceMappingURL=workflow-designer-point.model.js.map